import injector from 'vue-inject'
import moment from 'moment'

const cartElementBuilder = injector.get('CartElementBuilder')
const diningPreferenceType = injector.get('diningPreferenceType')

let stateGroup
let acStationName = ''
class OrderRowWorkStationParser {
  constructor (order, menu, item) {
    this.order = order
    this.menu = menu
    this.item = item
    this.exOrderInfo = {}
  }
  parse (questions) {
    let items = []
    let options = []
    questions.map(q => {
      const { items: coItems, options: coOptions } = this.parseOptionValue(q, q.instanceId, q.type, q.value)
      items = items.concat(coItems)
      options = options.concat(coOptions)
    })
    return {
      items: items,
      options: options
    }
  }
  parseOptionValue (question, qInsId, type, optionValue) {
    if (question.hasValue === false) {
      return {
        items: [],
        options: []
      }
    }
    if (type === 'numberGroup') {
      return this.parseNumOption(question, qInsId, optionValue)
    } else if (type === 'radio') {
      return this.parseOptionById(question, qInsId, optionValue)
    } else {
      return this.parseOptionById(question, qInsId, question.selectedOption.id)
    }
  }
  parseNumOption (question, qInsId, optionValue) {
    let items = []
    let options = []
    Object.keys(optionValue).forEach((opKey, index) => {
      const { items: coItems, options: coOptions } = this.parseOptionById(question, qInsId, opKey, optionValue[opKey], index)
      items = items.concat(coItems)
      options = options.concat(coOptions)
    })
    return {
      items: items,
      options: options
    }
  }
  parseOptionById (question, qInsId, optionId, numValue, numIndex = 0) {
    let opBiulder = cartElementBuilder.buildOption(optionId, this.item, this.menu)
    let itemModel = {}
    let items = []
    let options = []
    let exOptions = []
    let exItems = []
    let isItem = false
    let moreQuestions = this.parse(opBiulder.questions)

    if (moreQuestions) {
      if (moreQuestions['items']) {
        itemModel.items = items.concat(moreQuestions['items'])
      }
      if (moreQuestions['options']) {
        itemModel.options = moreQuestions.options
      }
    }

    Object.keys(chkStationMap).map(k => {
      if (opBiulder.kitchenStationId[k]) {
        isItem = true
      }
    })

    if (itemModel.items) {
      exItems = itemModel.items
      delete itemModel.items
    }

    if (isItem === true) {
      itemModel.id = opBiulder.id
      itemModel.option = true
      itemModel.title = (opBiulder.title === '') ? question.title : opBiulder.title
      itemModel.price = opBiulder.price
      itemModel.key = stateGroup === true ? this.item.instanceId : this.item.instanceId + '-' + qInsId + '-' + numIndex
      if (numValue) itemModel.number = numValue
      items.push(Object.assign(itemModel, this.exOrderInfo))
    } else {
      itemModel.id = opBiulder.id
      itemModel.title = (opBiulder.title === '') ? question.title : opBiulder.title
      itemModel.price = opBiulder.price
      if (numValue) itemModel.number = numValue

      if (itemModel.options) {
        itemModel.options.map(op => {
          let opB = cartElementBuilder.buildOption(op.id, this.item, this.menu)
          let option = {
            id: opB.id,
            title: (opB.title === '') ? op.title : opB.title,
            price: opB.price
          }
          if (op.number) option.number = op.number
          exOptions.push(option)
        })
        itemModel.options = []
      }
      options.push(itemModel)
      options = options.concat(exOptions)
    }

    if (exItems.length > 0) {
      items = items.concat(exItems)
    }

    return {
      items: items,
      options: options
    }
  }
}
let chkStationMap = {}
export default {
  orderRowToWorkStationFormat: function (stationMap, stationName, menus, orderList, store, currentMinute) {
    chkStationMap = stationMap
    stateGroup = injector.get('storeSetting').store.touchStateGrouped
    acStationName = stationName
    let result = getAllItem(menus, orderList.filter(o => {
      if (
        o.diningPreference === diningPreferenceType.preOrder &&
        (!moment(currentMinute).clone().add(store.preOrderDisplayBoundaryMinutes, 'm').isAfter(o.pickupTime) ||
          (store.shouldPreOrderPrePaid && !o.paidAt))
      ) {
        return false
      }
      return true
    }))

    return {
      items: result.list,
      needMenus: result.needMenus
    }
  },
  orderItemToWorkStationFormat: function (stationMap, stationName, order, Item, menu) {
    chkStationMap = stationMap
    acStationName = stationName
    stateGroup = injector.get('storeSetting').store.touchStateGrouped
    let list = getItemDetail(order, Item, menu)
    return list
  }
}

function getItemDetail (order, Item, menu, exOrderInfo = {}) {
  let detailList = []
  let itembuilder = cartElementBuilder.buildItem(Item, menu)
  let questions = itembuilder.questions
  let orderRowParser = new OrderRowWorkStationParser(order, menu, Item)
  const { items: coItems, options: coOptions } = orderRowParser.parse(questions)
  detailList.push(Object.assign({
    title: itembuilder.abbreviation,
    price: itembuilder.price,
    key: Item.instanceId,
    id: itembuilder.id,
    options: coOptions
  }, exOrderInfo))
  detailList = detailList.concat(coItems)
  return detailList
}

function getItemDetailFilter (order, Item, menu, exOrderInfo = {}) {
  let detailList = []
  let itembuilder = cartElementBuilder.buildItem(Item, menu)

  let questions = itembuilder.questions
  let orderRowParser = new OrderRowWorkStationParser(order, menu, Item)
  const { items: coItems, options: coOptions } = orderRowParser.parse(questions)
  detailList.push(Object.assign({
    title: itembuilder.abbreviation,
    price: itembuilder.price,
    key: Item.instanceId,
    id: itembuilder.id,
    options: coOptions
  }, {}))
  detailList = detailList.concat(coItems)
  let items = detailList.filter(i => {
    let itembuilder = null
    if (i.option === true) {
      itembuilder = cartElementBuilder.buildOption(i.id, Item, menu)
    } else {
      itembuilder = cartElementBuilder.buildItem(i, menu)
    }

    if (itembuilder.kitchenStationId[acStationName] === true) {
      exOrderInfo.id = Item.id
      return true
    }
    return false
  })
  // return {
  //   info: exOrderInfo,
  //   items: items
  // }
  return items
}

function getAllItem (menus, orderList) {
  let listWorkStation = []
  let needMenus = []
  orderList.forEach(order => {
    let listByOrder = []
    if (!menus[order.menuVariation]) return
    if (!menus[order.menuVariation][order.menuVersion]) return
    let exOrderInfo = {
      nickname: order.nickname,
      receivedAt: order.receivedAt,
      pickupTime: order.pickupTime,
      diningPreference: order.diningPreference,
      tableNumber: order.tableNumber,
      totalPrice: order.totalPrice,
      orderId: order.id
    }
    order.data.items.forEach(Item => {
      let list = getItemDetailFilter(order, Item, menus[order.menuVariation][order.menuVersion], exOrderInfo)

      // 將 item 底下的 optionItem 都收進自己本身
      // let mainItemIndex = -1
      // list = list.reduce((prev, element, index) => {
      //   if (!element.option) { // 餐點
      //     mainItemIndex++
      //     element.subItems = []
      //     prev.push(element)
      //     return prev
      //   } else { // optionItem
      //     prev[mainItemIndex].subItems.push(element)
      //     return prev
      //   }
      // }, [])

      if (list.length > 0) {
        listByOrder.push({
          instanceId: Item.instanceId,
          items: list,
          specialRequests: Item.specialRequests
        })
      }
    })
    if (listByOrder.length > 0) {
      listWorkStation.push({
        items: listByOrder,
        info: exOrderInfo
      })
    }
  })
  return {
    list: listWorkStation,
    needMenus: needMenus
  }
}

// function getAllItem (menus, orderList) {
//   let listWorkStation = []
//   let needMenus = []
//   orderList.forEach(order => {
//     if (!menus[order.menuVariation]) return
//     if (!menus[order.menuVariation][order.menuVersion]) return
//     let exOrderInfo = {
//       nickname: order.nickname,
//       receivedAt: order.receivedAt,
//       diningPreference: order.diningPreference,
//       tableNumber: order.tableNumber,
//       totalPrice: order.totalPrice
//     }
//     order.data.items.forEach(Item => {
//       let list = getItemDetailFilter(Item, menus[order.menuVariation][order.menuVersion], exOrderInfo)
//       if (list.items.length > 0) {
//         listWorkStation.push(list)
//       }
//     })
//   })
//   return {
//     list: listWorkStation,
//     needMenus: needMenus
//   }
// }
